import { IAppState } from '../../common/state';
import { IImage } from '../../types/newbuildingHeader';

export function getImages({ newbuildingInformation }: IAppState): IImage[] {
  return newbuildingInformation?.images || [];
}
